<div id="irt-reservations-root-layout" class="irt-full-height">
  <app-toolbar class="irt-toolbar" [currentItem]="navbarItem"></app-toolbar>
  <app-navbar class="irt-navbar" [currentItem]="navbarItem"></app-navbar>
  <app-reservations-section class="irt-section"></app-reservations-section>
</div>
